import { ReachAPI } from '../../ReachApi';
import { z } from 'zod';
import { forceTypingDeferred, getSecurityIdentity } from '../core';

type Quotes = {
    getQuotesForType: (
        quoteType: string,
        numberOfQuotes: number,
        security: ReachAPI.Security
    ) => JQueryDeferred<unknown>;
};

const quoteObjectSchema = z.object({
    author: z.string(),
    id: z.number(),
    quote: z.string(),
    title: z.string(),
    type: z.string().nullish(),
});

const quoteDataApiResponseSchema = z.object({
    quote_data: z.array(quoteObjectSchema),
});

/**
 * GET Endpoint `/quotes/`
 * @throws {@link ReachApiRetrievalError}
 */
export const getQuotesForType = function (
    quoteType: string,
    numberOfQuotes: number
): Promise<z.infer<typeof quoteDataApiResponseSchema>> {
    return forceTypingDeferred(
        quoteDataApiResponseSchema,
        (ReachAPI.quotes as Quotes).getQuotesForType(
            quoteType,
            numberOfQuotes,
            getSecurityIdentity()
        )
    );
};
